import { useState, useEffect } from 'react';
import { FLOW_BY_REVISION_TIMESTAMP_FIELD_NAME, GET_FLOW_BY_REVISION_TIMESTAMP } from 'automation-ui-canvas/containers/enrollment-history/utils/flowByRevisionQueries';
import Flow from 'automation-ui-canvas/flow/records/Flow/Flow';
import { useQuery } from 'data-fetching-client';
import { jsx as _jsx } from "react/jsx-runtime";
export const wireFlowByEnrollmentTimestamp = WrappedComponent => props => {
  var _logEvents$;
  const {
    flowId,
    logEvents
  } = props;

  /**
   * Getting the timestamp for the first(recently occured) log event.
   * This way it is ensured that we get the recent most information if the flow has been updated during this execution.
   */
  const revisionTimestamp = logEvents === null || logEvents === void 0 || (_logEvents$ = logEvents[0]) === null || _logEvents$ === void 0 ? void 0 : _logEvents$.timestamp;
  const {
    data: {
      [FLOW_BY_REVISION_TIMESTAMP_FIELD_NAME]: {
        flow = null
      } = {}
    } = {},
    loading: isFlowLoading,
    error: flowError
  } = useQuery(GET_FLOW_BY_REVISION_TIMESTAMP, {
    skip: !revisionTimestamp,
    variables: {
      flowId,
      revisionTimestamp: revisionTimestamp
    }
  });
  const [flowRecord, setFlowRecord] = useState(null);
  useEffect(() => {
    if (flow && flow.version !== (flowRecord === null || flowRecord === void 0 ? void 0 : flowRecord.version)) {
      setFlowRecord(new Flow(flow));
    }
  }, [flow, flowRecord]);
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    flow: flowRecord,
    flowError: flowError,
    isFlowLoading: isFlowLoading
  }));
};